import { Icon, MenuTab } from '@main/core-ui';
import { getMessageAsString } from '@main/internationalization';
import { FocusButton } from '@main/pc-core-components';
import type { MessageValues } from '@transcend-io/internationalization';
import React from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';

import { CountWrapper, TabWrapper } from './wrappers';

export interface TabProps {
  /** The menu tab to render */
  tab: MenuTab;
  /** Message values */
  values?: MessageValues;
  /** Click handle */
  onClick: () => void;
  /** If the tab is currently selected, for aria  */
  isSelected: boolean;
}

/**
 * Render a side menu tab
 */
export const Tab = ({
  tab: { count, title, hasRequestFiles, showCount },
  values,
  onClick,
  isSelected,
}: TabProps): JSX.Element => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const titleMessage =
    title && getMessageAsString(title, formatMessage, values);

  return (
    <TabWrapper>
      <FocusButton onClick={onClick} aria-current={isSelected}>
        {titleMessage}
      </FocusButton>
      {showCount && count && count > 0 ? (
        <CountWrapper>{count}</CountWrapper>
      ) : undefined}
      {!showCount && hasRequestFiles ? (
        <Icon type="paperclip" color={theme.colors.accentOnSidebar} />
      ) : undefined}
    </TabWrapper>
  );
};
